import { render, staticRenderFns } from "./PT250FAQTopParts.vue?vue&type=template&id=1a772164&"
import script from "./PT250FAQTopParts.vue?vue&type=script&lang=js&"
export * from "./PT250FAQTopParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports